import { Select } from '@tencent/tea-component';
import { t } from 'common-translation/tools';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const monthOption = new Array(12).fill(1).map((val, key) => {
  return {
    text: `${key + 1}月`,
    value: key + 1,
  };
});
const dateOption = new Array(31).fill(1).map((val, key) => {
  return {
    text: `${key + 1}`,
    value: key + 1,
  };
});
const thisYear = new Date().getFullYear();
const yearOption = new Array(thisYear).fill(1).map((val, key) => {
  return {
    text: `${thisYear - key}`,
    value: thisYear - key,
  };
});

export default function CustomDatePicker(props) {
  const { value, onBlur } = props;
  const form = useFormContext();

  const [finalValue, updateFinalValue] = useState('');
  const finalRef = useRef({});

  const handleChange = (val, type) => {
    finalRef.current[type] = val;
    updateFinalValue({ ...finalRef.current });
    if (Object.values(finalRef.current).filter((item) => !!item).length === 3) {
      const res = form.handler.change(
        props.name,
        moment().set({
          ...finalRef.current,
          month: finalRef.current.month - 1,
        }),
      );
      if (_.isFunction(onBlur)) {
        onBlur();
      }
      return res;
    }
  };

  useEffect(() => {
    if (value) {
      const final = {
        year: moment(value).get('year'),
        month: moment(value).get('month') + 1,
        date: moment(value).get('date'),
      };

      finalRef.current = final;
      updateFinalValue(final);
    }
  }, [value]);

  const monthLocale = {
    1: t('1月'),
    2: t('2月'),
    3: t('3月'),
    4: t('4月'),
    5: t('5月'),
    6: t('6月'),
    7: t('7月'),
    8: t('8月'),
    9: t('9月'),
    10: t('10月'),
    11: t('11月'),
    12: t('12月'),
  };

  return (
    <div className="form-group-split-date">
      <Select
        options={monthOption.map((item) => {
          return {
            ...item,
            text: monthLocale[item.value],
          };
        })}
        matchButtonWidth
        placeholder={t('月')}
        value={finalValue.month}
        className="form-group-split-date-item"
        onChange={(e) => handleChange(e, 'month')}
      />

      <Select
        options={dateOption}
        matchButtonWidth
        placeholder={t('日')}
        value={finalValue.date}
        className="form-group-split-date-item"
        onChange={(e) => handleChange(e, 'date')}
      />

      <Select
        options={yearOption}
        matchButtonWidth
        placeholder={t('年')}
        value={finalValue.year}
        className="form-group-split-date-item"
        onChange={(e) => handleChange(e, 'year')}
      />
    </div>
  );
}
